export function ending(count: number, one: string, couple: string, more: string) {
    const absoluteCount = Math.abs(count);
    const lastDigit = absoluteCount % 10;
    const lastTwoDigits = absoluteCount % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return more;
    }

    if (lastDigit === 1) {
        return one;
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
        return couple;
    }

    return more;
}
